var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "新增" : "修改",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: { model: _vm.dataForm, "label-width": "120px" },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.dataFormSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "数据源", prop: "datasourceId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "数据源" },
                  model: {
                    value: _vm.dataForm.datasourceId,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "datasourceId", $$v)
                    },
                    expression: "dataForm.datasourceId",
                  },
                },
                _vm._l(_vm.datasourceList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.text, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "表单编号", prop: "code" } },
            [
              _c("el-input", {
                attrs: { placeholder: "表单编号" },
                model: {
                  value: _vm.dataForm.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "code", $$v)
                  },
                  expression: "dataForm.code",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "表单标题", prop: "title" } },
            [
              _c("el-input", {
                attrs: { placeholder: "表单标题" },
                model: {
                  value: _vm.dataForm.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "title", $$v)
                  },
                  expression: "dataForm.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "表单类型", prop: "formType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "表单类型" },
                  model: {
                    value: _vm.dataForm.formType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "formType", $$v)
                    },
                    expression: "dataForm.formType",
                  },
                },
                _vm._l(_vm.formTypeList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.text, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "业务类型", prop: "formType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "业务类型" },
                  model: {
                    value: _vm.dataForm.busType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "busType", $$v)
                    },
                    expression: "dataForm.busType",
                  },
                },
                _vm._l(_vm.busTypeList, function (item) {
                  return _c("el-option", {
                    key: item.type,
                    attrs: { label: item.text, value: item.type },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.dataForm.formType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "是否支持附件", prop: "hasAttach" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: {
                        display: "block",
                        "margin-bottom": "10px",
                      },
                      attrs: { placeholder: "是否支持附件" },
                      model: {
                        value: _vm.dataForm.hasAttach,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "hasAttach", $$v)
                        },
                        expression: "dataForm.hasAttach",
                      },
                    },
                    _vm._l(_vm.trueOrFalseOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.text, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.formType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "是否支持流程", prop: "hasFlow" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: {
                        display: "block",
                        "margin-bottom": "10px",
                      },
                      attrs: { placeholder: "是否支持流程" },
                      model: {
                        value: _vm.dataForm.hasFlow,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "hasFlow", $$v)
                        },
                        expression: "dataForm.hasFlow",
                      },
                    },
                    _vm._l(_vm.trueOrFalseOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.text, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.formType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "流程模板键值", prop: "flowTemplateKey" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "流程模板键值" },
                    model: {
                      value: _vm.dataForm.flowTemplateKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "flowTemplateKey", $$v)
                      },
                      expression: "dataForm.flowTemplateKey",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "dataSort" } },
            [
              _c("el-input", {
                attrs: { placeholder: "排序" },
                model: {
                  value: _vm.dataForm.dataSort,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "dataSort", $$v)
                  },
                  expression: "dataForm.dataSort",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }